import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import getConfiguration, { errorHandler } from 'core/store/config';
import { ThunkApiConfig } from 'core/store';
import {
  AuthenticateRequestRequest,
  AuthenticationControllerApi,
  AuthenticationResponseDto,
  Configuration,
  ControllerPerLaGestioneDellimpersonazioneApplicativaApi,
  ImpersonationTokenOutputDto,
  SignInRequestDto,
} from '@api/client';

export enum AuthReducer {
  login = '[AUTH] Login',
  renew = '[AUTH] Renew',
  logout = '[AUTH] Logout',
  startImpersonation = '[AUTH] Start Impersonation',
  stopImpersonation = '[AUTH] Stop Impersonation',
}

export const authLogin = createAsyncThunk<AuthenticationResponseDto | undefined, SignInRequestDto, ThunkApiConfig>(
  AuthReducer.login,
  async (values, { dispatch, extra, getState }) => {
    try {
      let request: AuthenticateRequestRequest = {
        signInRequestDto: values,
      };

      return await new AuthenticationControllerApi(
        getConfiguration(Configuration, extra, getState)
      ).authenticateRequest(request);
    } catch (e) {
      console.error('authLogin error', e);
    }
  }
);

export const authRenew = createAsyncThunk<AuthenticationResponseDto | undefined, void, ThunkApiConfig>(
  AuthReducer.renew,
  async (_, { dispatch, extra, getState }) => {
    try {
      return await new AuthenticationControllerApi(
        getConfiguration(Configuration, extra, getState)
      ).renewAuthentication();
    } catch (e) {
      console.error('authRenew error', e);
    }
  }
);

export const authLogout = createAction<boolean | undefined>(AuthReducer.logout);

export const authStartImpersonation = createAsyncThunk<
  ImpersonationTokenOutputDto | undefined,
  { targetUsername: string; reason?: string },
  ThunkApiConfig
>(AuthReducer.startImpersonation, async ({ targetUsername, reason }, { dispatch, extra, getState }) => {
  try {
    return await new ControllerPerLaGestioneDellimpersonazioneApplicativaApi(
      getConfiguration(Configuration, extra, getState)
    ).startImpersonation({ targetUsername, impersonationStartRequestDto: { reason } });
  } catch (e) {
    errorHandler(e, dispatch, getState);
  }
});

export const authStopImpersonation = createAsyncThunk<void, void, ThunkApiConfig>(
  AuthReducer.stopImpersonation,
  async (_, { dispatch, extra, getState }) => {
    try {
      await new ControllerPerLaGestioneDellimpersonazioneApplicativaApi(
        getConfiguration(Configuration, extra, getState)
      ).stopImpersonation();
    } catch (e) {
      console.error('authStopImpersonation error', e);
    }
  }
);
